import {EventEmitter} from "events";

export const uiBus = new EventEmitter();
